
import { Component, Vue } from 'vue-property-decorator';
import dialogSelectCustomer from '@/components/CustomerDialog/levelByLevel.vue';
import {
  groupCsList,
  addGroupCs,
  editGroupCs,
  delGroupCs
} from '@/api/group';
import { IPagination } from '@/types';
import { UserModule } from '@/store/modules/user';
import { parseTime } from '../../utils';

@Component({
  name: 'CustomerGroupsAlias',
  components: {
    dialogSelectCustomer
  }
})
export default class extends Vue {
  private pagination: IPagination = {
    currentPage: 1,
    pageSize: 10,
    total: 0
  };

  private page = 1;
  private size = 10;

  private formSearch = {
    customer: ''
  };
  private tableData = [];

  private customerVisible = false;
  private isCheckbox = true;
  private dialogSelectDeptStaffVisible = false;
  private dynamicTagsDept = [];
  private formDeptDept = {
    name: ''
  };

  private listLoading = false;

  created() {
    this.getAuthGroup();
  }

  handleCurrentChange(size: number) {
    this.page = size;
    this.getAuthGroup();
  }

  handlePageSizeChange(size: number) {
    this.size = size;
    this.getAuthGroup();
  }
  // 搜索
  private handleSearch() {
    this.getAuthGroup();
  }

  // 清空
  private handleSearchClear() {
    this.formSearch = {
      customer: ''
    };
    this.getAuthGroup();
  }

  private getAuthGroup() {
    this.listLoading = true;
    // group_state 查看客户群组权限: 1 客户别名推单群组: 5
    const params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      customer_name: this.formSearch.customer,
      page: this.page,
      size: this.size,
      group_type: 5
    };
    groupCsList(params)
      .then((res: any) => {
        const data = res.data;
        if (data !== null) {
          this.pagination.currentPage = parseInt(data.page_current);
          this.pagination.total = parseInt(data.count);
          this.tableData = data.list;
        } else {
          this.pagination.currentPage = 1;
          this.pagination.total = 0;
          this.tableData = [];
        }
        this.listLoading = false;
      })
      .catch((err: any) => {
        this.tableData = [];
        this.listLoading = false;
        let msg = err.msg;
      });
  }

  private editData: any = null;

  private addOperationhandle() {
    this.editData = {};
    this.customerVisible = true;
  }

  private operationhandle(val: any) {
    this.editData = val;
    this.customerVisible = true;
  }

  private closeSelectCustomerHandle() {
    this.selectCusromer = [];
    this.editData = {};
    this.customerVisible = false;
  }

  private selectCusromer: any = [];
  // 下一步
  private selectCustomerHandle(value: any) {
    this.selectCusromer = value;
    this.addAuthGroup();
  }
  private addAuthGroup() {
    var v = '';
    if (this.editData.group_name) {
      v = this.editData.group_name;
    }
    this.$prompt('名称', '群组名称', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      inputPlaceholder: '请输入群组名称',
      inputPattern: /^[A-Za-z0-9\u4e00-\u9fa5]{2,30}$/,
      inputErrorMessage: '请输入2-30位由数字、字母、中文组成的名称',
      inputValue: v
    })
      .then(({ value }: any) => {
        // this.$message({
        //   type: 'success',
        //   message: '群组名称是: ' + value
        // });
        const params:any = {
          user_id: UserModule.getUserId,
          company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
          group_name: value,
          group_type: '5'
        };
        let customers:any = [];
        this.selectCusromer.forEach((element:any) => {
          let customer:any = {};
          customer.user_id = element.customer_user_id;
          customer.user_name = element.name;
          customer.company_id = element.customer_company_id;
          customer.company_name = element.name;
          customer.type = element.customer_type;
          customers.push(customer);
        });
        params.customer = JSON.stringify(customers);
        if (this.editData && this.editData.id) {
          params.group_id = this.editData.id;
          this.edit(params);
        } else {
          this.add(params);
        }
      })
      .catch(() => {

      });
  }

  private add(params: any) {
    addGroupCs(params)
      .then((res) => {
        this.customerVisible = false;
        this.dialogSelectDeptStaffVisible = false;
        this.showSuccessMsg('添加成功');
        this.getAuthGroup();
      })
      .catch((err) => {
        this.showErrorMsg(err);
      });
  }

  private edit(params:any) {
    editGroupCs(params)
      .then((res) => {
        this.customerVisible = false;
        this.dialogSelectDeptStaffVisible = false;
        this.showSuccessMsg('修改成功');
        this.getAuthGroup();
      })
      .catch((err) => {
        this.showErrorMsg(err);
      });
  }

  private deleteAuthGroup(val: any) {
    this.$confirm('确认删除吗?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        const params = {
          user_id: UserModule.getUserId,
          company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
          group_id: val.id
        };
        delGroupCs(params)
          .then((res) => {
            this.showSuccessMsg('删除成功');
            this.getAuthGroup();
          })
          .catch((err) => {
            this.showErrorMsg(err);
          });
      })
      .catch(() => {});
  }

  private deptListSelectionAll() {}
  private deptListSelection() {}

  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSuccessMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: window.innerHeight * 0.4,
      customClass: 'notification-center',
      type: 'success'
    });
  }
}
